export default __webpack_public_path__ + "d4ee44b520f97b7272da035b9edd5291.png";